$("#btn_alcaldia" ).click(function() {
	$("#btn_alcaldia").addClass("active");
	$("#btn_solicitudes").removeClass("active")
	$("#btn_busca").removeClass("active");
	$("#btn_mi_ubicacion").removeClass("active");
	
	$("#select_alcaldias" ).removeClass( "d-none" );
	$("#select_clasificaciones" ).addClass( "d-none" );
	$("#buscar_nombre" ).addClass( "d-none" );
});

$("#btn_solicitudes" ).click(function() {
	$("#btn_alcaldia").removeClass("active");
	$("#btn_solicitudes").addClass("active");
	$("#btn_busca").removeClass("active");
	$("#select_clasificaciones" ).removeClass( "d-none" );
	$("#select_alcaldias" ).addClass( "d-none" );
	$("#buscar_nombre" ).addClass( "d-none" );
	$("#btn_mi_ubicacion").removeClass("active");
});

$("#btn_busca" ).click(function() {
	$("#btn_busca").addClass("active");
	$("#btn_alcaldia").removeClass("active");
	$("#btn_solicitudes").removeClass("active");
	$("#select_clasificaciones" ).addClass( "d-none" );
	$("#select_alcaldias" ).addClass( "d-none" ); 
	$("#buscar_nombre" ).removeClass( "d-none" );
	$("#btn_mi_ubicacion").removeClass("active");
});

$("#btn_mi_ubicacion" ).click(function() {
	$("#btn_mi_ubicacion").addClass("active");
	$("#btn_alcaldia").removeClass("active");
	$("#btn_busca").removeClass("active");
	$("#btn_solicitudes").removeClass("active");
	$("#select_clasificaciones" ).addClass( "d-none" );
	$("#select_alcaldias" ).addClass( "d-none" ); 
	$("#buscar_nombre" ).addClass( "d-none" );
});

$( document ).ready(function() {
	$("#select_alcaldias").change(function() {
    	$("#form_alcaldia").submit();
 	});
});

function set_cerca_de_ti() {
	$("#btn_ver_todo").removeClass("active");
    $( "#btn_mi_ubicacion" ).addClass("active");

    var latlngStr = mi_ubicacion.split(',', 2);
    var center = new google.maps.LatLng(latlngStr[0], latlngStr[1]);
    map.panTo(center);
    map.setZoom(14);
    var marker = new google.maps.Marker({
        position: center,
        title:"Estas aquí",
        icon: {                             
            url: base_url+"/images/stock/rectangle.png"                           
        }
    });
    marker.setMap(map);
}
